module.exports = __webpack_public_path__ + "startpage-746fed5a/cover-letter-a3a27eeeecf3cb0db32de2422756e3aa.png";